<template>
  <!-- <Header />   -->
  <Header @toggle-sidebar="isSidebarOpen = !isSidebarOpen" />
  <FlashMessage />
  <router-view :key="$route.fullPath" />
  <ChatComponent v-if="chatVisible" />
  <div v-if="footerVisible">
    <Footer />
  </div>

  <!-- Sidebar lives globally -->
  <!-- <Sidebar :isOpen="isSidebarOpen" @close="isSidebarOpen = false" /> -->
  <Sidebar
    v-if="!route.meta.hideSidebar"
    :is-open="isSidebarOpen"
    @close="isSidebarOpen = false"
  />
</template>

<script>
import FlashMessage from "@/components/FlashMessage.vue";
import Header from '@/components/include/Header.vue';
import Footer from '@/components/include/Footer.vue';
import ChatComponent from '@/components/ChatComponent.vue';
import Sidebar from "@/components/homepage/Sidebar.vue";
import { useRoute } from 'vue-router';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    ChatComponent,
    FlashMessage,
    Sidebar
  },
  setup() {
    const route = useRoute(); // get current route
    return { route };
  },
  data() {
    return {
      footerVisible: false, // Controls Footer visibility
      chatVisible: false,   // Controls ChatComponent visibility
      isSidebarOpen: false,
    };
  },
  created() {
    // Clear storage after 1 hour
    setTimeout(() => {
      localStorage.clear();
      console.log("Storage Cleared");
    }, 1000 * 60 * 60);

    // Delay showing ChatComponent
    setTimeout(() => {
      this.chatVisible = false;
    }, 500); // Adjust delay for ChatComponent

    // Delay showing Footer
    setTimeout(() => {
      this.footerVisible = true;
    }, 1000); // Adjust delay for Footer
  },
};
</script>
